var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWineDetailsClassificationV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5227 4.45312H19.5768C18.7617 4.45312 17.9801 4.77715 17.4035 5.35313L4.90312 17.8535C4.30313 18.4535 4.30313 19.4268 4.90312 20.0268L9.97324 25.0969C10.5732 25.6969 11.5465 25.6969 12.1465 25.0969L24.6469 12.5965C25.2234 12.0199 25.5469 11.2383 25.5469 10.4232V5.47734C25.5469 4.91133 25.0881 4.45312 24.5227 4.45312Z",
    stroke: "#150036",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3281 10.0781C22.1048 10.0781 22.7344 9.44853 22.7344 8.67188C22.7344 7.89522 22.1048 7.26562 21.3281 7.26562C20.5515 7.26562 19.9219 7.89522 19.9219 8.67188C19.9219 9.44853 20.5515 10.0781 21.3281 10.0781Z",
    stroke: "#150036",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWineDetailsClassificationV2);
export default __webpack_public_path__ + "static/media/wine-details-classification-V2.5044509c0b64df3a92fe6a623ee3935d.svg";
export { ForwardRef as ReactComponent };